module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ../~/fbjs/~/core-js/library/modules/$.iter-step.js
// module id = 343
// module chunks = 17